import { styled, Select as MuiSelect, ListItem as MuiListItem } from '@mui/material';
import { Typography as RocketTypography } from "@totalsoft/rocket-ui";
import styles from 'assets/jss/styles';

export const Select = styled(MuiSelect)(({ theme }) => ({
  width: '100%',
  verticalAlign: 'middle',
  color: 'inherit',
  marginBottom: theme.spacing(1),
  '&:before,&:after': {
    display: 'none !important'
  },
  [`.MuiSelect-select`]: {
    textOverflow: 'unset',
    paddingLeft: '10px',
    paddingBlock: theme.spacing(1.5)
  },
  [`.MuiSelect-icon`]: {
    color: theme.palette.sideMenu.color,
    right: '10px'
  }
}));

export const ListItem = styled(MuiListItem)(({ theme }) => ({
  paddingInline: theme.spacing(2),
  paddingBlock: theme.spacing(1)
}));

export const Typography = styled(RocketTypography)(({ theme }) => ({
  ...styles(theme)?.defaultFont,
  margin: '0',
  position: 'relative',
  transform: 'translateX(0px)',
  opacity: '1',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  transition: 'transform 300ms ease 0s, opacity 300ms ease 0s',
  fontSize: '15px',
  fontWeight: 'bold',
  paddingLeft: '25px'
}));
